// Sidebar.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Assuming you use React Router for navigation
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { collection, doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';

const Sidebar = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Check if the user is logged in
        if (auth.currentUser) {
          const userId = auth.currentUser.uid;
          const docRef = doc(db, "userInfo", userId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserData(docSnap.data());
          } else {
            console.log("No such document!");
          }
        } else {
          console.log("User is not logged in!");
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className='ha_side_bar_main'>
      {userData && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar alt="User Avatar" src='' />
          <div style={{ marginLeft: '10px' }}>
            <Typography style={{ color: 'white' }} variant="h6">{userData.displayname}</Typography>
            <Typography style={{ color: 'white' }} variant="body2">{userData.email}</Typography>
          </div>
        </div>
      )}

      <ul className='Ha_sidebr_btn'>
        <li>
          <Link to="/admin/">Home</Link>
        </li>
        {/* <li>
          <Link to="/admin/Adminsettings">settings</Link>
        </li>
        <li>
          <Link to="/admin/Adminuser">user</Link>
        </li> */}
      </ul>
    </div>
  );
};

export default Sidebar;
